
export function BranchModel(dict) {
    this.category = dict.Category || null;
    this.isBranchOpen = dict.IsBranchOpen || false;
    this.isPickupBranchOpen = dict.IsPickupBranchOpen || false;
    this.lineChannelID = dict.LineChannelID || null;
    this.website = dict.Website || null;
    this.address = dict.address || null;
    this.addressEN = dict.address_en || null;
    this.buzz = dict.buzz || null;
    try {
        this.contactNumber = JSON.parse(dict.contact_number);
    } catch (error) {
        this.contactNumber = null;
    }
    this.description = dict.description || null;
    this.descriptionEN = dict.escription_en || null;
    this.distance = dict.distance || null;
    this.districtCode = dict.district_code || null;
    this.expert = dict.expert || null;
    this.id = dict.id.replace("IC", "") || null;
    this.imageUrl = dict.image_url || null;
    this.isBuzzeBeesPlace = dict.isBuzzeBeesPlace || false;
    this.like = dict.like || null;
    this.location = dict.location || null;
    this.name = dict.name || null;
    this.nameEN = dict.name_en || null;
    this.provinceCode = dict.province_code || null;
    this.rank = dict.rank || null;
    this.referenceCode = dict.reference_code || null;
    this.region = dict.region || null;
    this.regionEN = dict.region_en || null;
    this.services = dict.services || null;
    this.subdistrictCode = dict.subdistrict_code || null;
    this.workingDay = dict.working_day || null;
    this.workingDayEn =  dict.working_day_en || null;
    this.pickupWorkingDayEn =  dict.pickup_working_day_en || null;
    this.pickupWorkingDay =  dict.pickup_working_day || null;
    this.isOnline =  dict.IsOnline || null;
}